<script>
import TwButton from '@/components/generic/tw-button.vue'
import FundraiserSubscribeToUpdatesModal from '@/components/fundraiser-updates/fundraiser-subscribe-to-updates-modal.vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import FundraiserSocialsShare from '@/components/fundraisers/fundraiser-socials-share.vue'
import { PlusIcon } from '@heroicons/vue/24/outline'
import FundraiserPageSelectorPublic from '@/components/fundraiser-pages/fundraiser-page-selector-public.vue'

export default {
  name: 'FundraiserActions',
  components: { FundraiserPageSelectorPublic, FundraiserSocialsShare, TwModal, FundraiserSubscribeToUpdatesModal, TwButton, PlusIcon },
  props: {
    fundraiser: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      DonateToFundraiserPage: null
    }
  },
  methods: {
    async donateToFundraiserPage() {
      if(!this.DonateToFundraiserPage) {
        this.$notify('Please select a supporter you want to donate to first', 'warning')
        return
      }
      this.$router.push({name: 'FundraiserPageDonatePage', params:{ fundraiserPageId: this.DonateToFundraiserPage.id }})
    }
  }
}
</script>

<template>
  <div class="flex flex-col gap-3">
    <div v-if="fundraiser.settings.force_donating_to_fundraiser_pages_only">
      <fundraiser-page-selector-public v-if="fundraiser" v-model="DonateToFundraiserPage" class="mb-4" :fundraiser="fundraiser" />
      <tw-button block size="lg" class="w-full" variant="primary" @click="donateToFundraiserPage">
        Donate <span v-if="DonateToFundraiserPage"> to <span class="font-semibold"> {{ fundraiser.settings?.lock_title? DonateToFundraiserPage.cached.owner_name :DonateToFundraiserPage.title }} </span> </span>
      </tw-button>
    </div>
    <tw-button v-else :to="{ name: 'FundraiserDonatePage', params: { fundraiserId: fundraiser.id } }" block size="lg" class="w-full" variant="primary">
      Donate
    </tw-button>
    <div class="flex gap-3">
      <tw-button block variant="secondary" class="text-md" @click="$refs.shareModal.open()">
        Share
      </tw-button>
      <tw-button block variant="secondary" class="text-md" @click="$refs.subscribeToFundraiserModal.open()">
        Subscribe
      </tw-button>
    </div>
    <fundraiser-subscribe-to-updates-modal ref="subscribeToFundraiserModal" :subscribable="fundraiser" />
    <tw-modal ref="shareModal" ok-only ok-text="Close" variant="secondary" title="Share this fundraiser" @ok="$refs.shareModal.close()">
      <fundraiser-socials-share :fundraiser="fundraiser" />
    </tw-modal>
    <tw-button v-if="fundraiser.settings && fundraiser.settings.enable_supporters && !fundraiser.settings.lock_joining" :to="{ name: 'FundraiserPublicJoinPage', params: { fundraiserId: fundraiser.id } }" block variant="dark">
      Create Fundraiser for this cause <PlusIcon class="h-4 w-4" />
    </tw-button>
  </div>
</template>

<style scoped>

</style>
